import { connect } from 'react-redux'
import { resetRealityCheck, goToLobby, displayHistory, message } from '../../redux/actions'
import Component from '../component'
import Currency from '../../Utils/Currency'

/**
 * This is the Reality check prompt, which let's the user know
 * for how long they've played and how much money they've
 * lost or earned.
 */
@connect(state => state.session, { resetRealityCheck, goToLobby, displayHistory, message })
export default class RealityCheck extends Component {
  /**
   * Returns the user to the lobby.
   */
  returnToLobby = () => {
    this.props.goToLobby()
  }

  /**
   * Opens up the defined History url in a new window.
   */
  displayHistory = () => {
    this.props.displayHistory()
  }

  /**
   * Calls an action to request the reality check timer reset from
   * the server.
   * @param e
   */
  resetRealityCheck = (e) => {
    this.props.resetRealityCheck()
    this.props.message(null)
    e.preventDefault()
  }

  /**
   * Renders out a DOM element, with reality check information.
   * @returns {*}
   */
  render() {
    const { realityCheck, rchistoryurl } = this.props
    const { betSum, winSum, result, totalSessionMinutes } = realityCheck
    const realityMsg = this.t('realityCheck.message', {
      playTime: totalSessionMinutes,
      betAmount: Currency.format(betSum),
      winAmount: Currency.format(winSum),
      result: Currency.format(result)
    })

    return (
      <div className="popup-content realityCheck">
        <br />
        <div className="popup-message realityCheck" dangerouslySetInnerHTML={{ __html: realityMsg }} />
        <br />
        <div className="buttonContainer" style={{ textAlign: 'center', minWidth: '200px' }}>
          <button onClick={this.resetRealityCheck}>{this.t('realityCheck.confirm')}</button>
          <button onClick={this.returnToLobby}>{this.t('realityCheck.cancel')}</button>
          { rchistoryurl && <button onClick={this.displayHistory}>{this.t('realityCheck.history')}</button> }
        </div>
      </div>
    )
  }
}
